'use client';

import { createContext, useContext } from 'react';
import { SummaryProps } from '../../types/sumaryCard.types';
import { usePageSharedData } from '../usePageSharedData';

interface PageSharedDataContextType {
  detailItems: Array<{
    name: string;
    description: string;
    unit: number;
    unitDescription: string;
    value: string;
  }>;
  items: SummaryProps['items'];
  total: {
    amount: number;
    description: string;
    formattedAmount: string;
  };
  isRecurrence: boolean;
}

export const PageSharedDataContext = createContext<PageSharedDataContextType | null>(null);

export const usePageDataAdapter = () => {
  const statusPageData = useContext(PageSharedDataContext);
  const defaultPageData = usePageSharedData();

  if (statusPageData) {
    return {
      detailItems: statusPageData.detailItems,
      isRecurrence: statusPageData.isRecurrence,
      items: statusPageData.items,
      total: statusPageData.total,
      isReady: true,
    };
  }

  return defaultPageData;
};
